// extracted by mini-css-extract-plugin
export default {"wrapper":"BusinessTypeItem_wrapper__e+V-S","title":"BusinessTypeItem_title__tvZPN"};